import { trimChar } from "..";
import { BaseResource } from "./base.resource";
import { OpenContainer } from "./container.resource";

export const ItemAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
  Move: 1 << 3,
};

export class Item extends BaseResource {
  setContainer(container: OpenContainer) {
    this.containerNumber = container.containerNumber;
    this.wasteType = container.wasteType;
    this.weightUnits = container.weightUnits;
  }
  revision: number;
  itemNumber: string;
  wasteType: string;
  itemDetail: string;
  description: string;
  physicalState: string;
  itemContainerMaterial: string;
  containerNumber: string;
  containerOpen: boolean;
  trackingNumber: string;
  isEmptyDrum: boolean;
  isLiquidPetrolium: boolean;
  isSolidPetrolium: boolean;
  spent: boolean;
  volume: number;
  volumeUnits: string;
  weight: number;
  weightUnits: string;
  get weightUn(): string {
    return this.weight !== null ? this.weight + " " + this.weightUnits : "";
  }
  get volumeUn(): string {
    return this.volume !== null ? this.volume + " " + this.volumeUnits : "";
  }
  numberOfItems: number;
  pickupDate: Date;
  enteredBy: string;
  enteredByName: string;
  owner: string;
  ownerName: string;
  phone: string;
  bldgNo: string;
  orgCode: string;
  chargeCode: string;
  labNo: string;
  streamName: string;
  labPackRcra?: boolean;
  wasteCode01: string;
  wasteCode02: string;
  wasteCode03: string;
  wasteCode04: string;
  wasteCode05: string;
  wasteCode06: string;
  wasteCode07: string;
  wasteCode08: string;
  wasteCode09: string;
  wasteCode10: string;
  get wasteCodesJoin(): string {
    let codes = trimChar(
      [
        this.wasteCode01,
        this.wasteCode02,
        this.wasteCode03,
        this.wasteCode04,
        this.wasteCode05,
        this.wasteCode06,
        this.wasteCode07,
        this.wasteCode08,
        this.wasteCode09,
        this.wasteCode10,
      ].join(", "),
      ", "
    );
    return (codes.match(/,/g) || []).length < 5 ? codes : codes.replaceAll(" ", "");
  }
  createdOn: Date;
  createdBy: string;
  updatedOn: Date;
  updatedBy: string;
  codes = Array(10)
    .fill("wasteCode")
    .map((wc, i) => wc + (i + 1).toString().padStart(2, "0"));

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }
  get isBulk(): boolean {
    return this.wasteType === "Bulk";
  }
  get isLabPack(): boolean {
    return this.wasteType === "LabPack";
  }
  get isRecycle(): boolean {
    return this.wasteType === "Recycle";
  }
  get canView(): boolean {
    return (this.accessLevel & ItemAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ItemAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & ItemAccessLevel.Delete) > 0;
  }
  get canMove(): boolean {
    return (this.accessLevel & ItemAccessLevel.Move) > 0;
  }
  get isValidRecycleType(): boolean {
    return this.isRecycle
      ? this.isSolidPetrolium === true ||
          this.isLiquidPetrolium === true ||
          this.isEmptyDrum === true
      : true;
  }
  setRecycleType(type: number) {
    this.isLiquidPetrolium = type === 0;
    this.isSolidPetrolium = type === 1;
    this.isEmptyDrum = type === 2;
  }
}
